var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pay-record-detail-container" }, [
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "card-wrapper" },
        [
          _c(
            "mobile-card",
            [
              _c("template", { slot: "title" }, [_vm._v("支付信息")]),
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "flex-form-info" }, [
                  _c("span", [_vm._v("订单编号")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatSpaceText")(_vm.selectRecord.orderNo)
                      )
                    )
                  ])
                ]),
                _c("div", { staticClass: "flex-form-info" }, [
                  _c("span", [_vm._v("订单状态")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatSpaceText")(_vm.selectRecord.stateStr)
                      )
                    )
                  ])
                ]),
                _c("div", { staticClass: "flex-form-info" }, [
                  _c("span", [_vm._v("订单金额")]),
                  _c("span", { staticClass: "money-item" }, [
                    _vm._v(
                      _vm._s(_vm._f("formatMoney")(_vm.selectRecord.money))
                    )
                  ])
                ]),
                _c("div", { staticClass: "flex-form-info" }, [
                  _c("span", [_vm._v("创建时间")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatSpaceText")(_vm.selectRecord.createTime)
                      )
                    )
                  ])
                ]),
                _c("div", { staticClass: "flex-form-info" }, [
                  _c("span", [_vm._v("支付方式")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatSpaceText")(_vm.selectRecord.payType)
                      )
                    )
                  ])
                ]),
                _c("div", { staticClass: "flex-form-info" }, [
                  _c("span", [_vm._v("支付时间")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatSpaceText")(_vm.selectRecord.payTime)
                      )
                    )
                  ])
                ]),
                _c("div", { staticClass: "flex-form-info" }, [
                  _c("span", [_vm._v("发票抬头")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatSpaceText")(_vm.selectRecord.ticketTitle)
                      )
                    )
                  ])
                ])
              ])
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "card-wrapper" },
        [
          _c(
            "mobile-card",
            [
              _c("template", { slot: "title" }, [_vm._v("订单明细")]),
              _c(
                "template",
                { slot: "content" },
                _vm._l(_vm.payDetail, function(item, index) {
                  return _c("div", { key: index }, [
                    _c("div", { staticClass: "flex-form-info" }, [
                      _c("span", [_vm._v(_vm._s(_vm.getOrderText(item)))]),
                      _c("span", { staticClass: "money-item" }, [
                        _vm._v(_vm._s(_vm._f("formatMoney")(item.payMoney)))
                      ])
                    ])
                  ])
                }),
                0
              )
            ],
            2
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "footer" }, [
      _c(
        "div",
        { staticClass: "footer-bar" },
        [
          _c(
            "mobile-button",
            { attrs: { color: "#005423" }, on: { click: _vm.onBack } },
            [_vm._v("返回上一级")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }